/** @type {import('tailwindcss').Config} */
export default {
  content: ["./index.html", "./src/**/*.{js,ts,jsx,tsx}", "./lib/**/*.{js,ts,jsx,tsx}"],
  theme: {
    extend: {
      colors: {
        content: {
          base: "#FFF",
          secondary: "#958ED8",
          disabled: "#59549F",
        },
        border: {
          base: "#45408D",
          subtle: "#231F55",
          transparent: "#FFFFFF29",
        },
        background: {
          baseSolid: "#0C0629",
          secondarySolid: "#151240",
          backdrop: "#0C0629D9",
        },
        primary: {
          base: "#562EF0",
          dark: "#411EB9",
          light: "#9389FC",
          lighter: "#D5D5FF",
          contrast: "#FFF",
          50: "#F3F3FF",
          100: "#EAE9FE",
          200: "#D5D5FF",
          300: "#B7B4FE",
          400: "#9389FC",
          500: "#7059F9",
          600: "#562EF0",
          700: "#4E24DD",
          800: "#411EB9",
          900: "#371B97",
          950: "#1F0E67",
        },
        secondary: {
          base: "#45408D",
          dark: "#312D6F",
          darker: "#231F55",
          light: "#59549F",
          lighter: "#8E89D1",
          contrast: "#FFF",
          50: "#EBE9FF",
          100: "#CCCDFF",
          200: "#B3ACEF",
          300: "#958ED8",
          400: "#8E89D1",
          500: "#59549F",
          600: "#45408D",
          700: "#312D6F",
          800: "#231F55",
          900: "#151240",
          950: "#0C0629",
        },
        informative: {
          base: "#23B4C9",
          dark: "#1E869C",
          darker: "#1F6D7F",
          light: "#3CC3D4",
          lighter: "#BOEBF1",
        },
        warning: {
          base: "#D67D39",
          dark: "#C8672E",
          darker: "#A65028",
          light: "#E09F64",
          lighter: "#F1D7E7",
        },
        error: {
          base: "#EF4444",
          dark: "#DC2626",
          darker: "#B91C1C",
          light: "#F87171",
          lighter: "#FECACA",
        },
        success: {
          base: "#15A462",
          dark: "#14814F",
          darker: "#156642",
          light: "#49DF99",
          lighter: "#BAF8DA",
        },
        darkBrand: {
          50: "#EBE9FF",
          100: "#CCCDFF",
          200: "#B3ACEF",
          300: "#958ED8",
          400: "#8E89D1",
          500: "#59549F",
          600: "#45408D",
          700: "#312D6F",
          800: "#231F55",
          900: "#151240",
          950: "#0C0629",
        },
        accentBrand: {
          50: "#F3F3FF",
          100: "#EAE9FE",
          200: "#D5D5FF",
          300: "#B7B4FE",
          400: "#9389FC",
          500: "#7059F9",
          600: "#562EF0",
          700: "#4E24DD",
          800: "#411EB9",
          900: "#1F0E67",
          950: "#371B97",
        },
        gray: {
          50: "#F3F7FA",
          100: "#E9EFF6",
          200: "#B3ACEF",
          300: "#BECEE3",
          400: "#A3B6D6",
          500: "#8C9DC8",
          600: "#7482B7",
          700: "#6E79A7",
          800: "#515B82",
          900: "#464E69",
          950: "#292D3D",
        },
        slateBrand: {
          50: "#F1F4FC",
          100: "#E6EAF9",
          200: "#D2DAF3",
          300: "#B6C0EB",
          400: "#98A0E1",
          500: "#7F82D5",
          600: "#6965C6",
          700: "#5A55AD",
          800: "#4A478C",
          900: "#3F3E70",
          950: "#262442",
        },
        brand: {
          50: "#FAF5FF",
          100: "#F2E8FF",
          200: "#E7D5FF",
          300: "#D4B3FF",
          400: "#BA83FD",
          500: "#9D4EF8",
          600: "#8A32EB",
          700: "#7621CF",
          800: "#6420A9",
          900: "#531B88",
          950: "#360665",
        },
      },
      backgroundImage: {
        header: "radial-gradient(133.74% 100.44% at 100% 50%, #231F55 0%, #151240 100%)",
        dialog: "radial-gradient(51.67% 51.19% at 51.67% 0%, #312D6F 0%, #151240 100%)",
        homeBtn: "linear-gradient(180deg, #312D6F 0%, #231F55 50.48%, #312D6F 100%)",
        grdPrimary: "radial-gradient(50% 100% at 50% 0%, #7059F9 0%, #4E24DD 100%)",
        grdPrimaryAlt: "linear-gradient(180deg, #371B97 0%, #411EB9 100%)",
        grdSecondary: "radial-gradient(50% 100% at 50% 0%, #312D6F 0%, #231F55 100%)",
        grdSecondaryAlt: "linear-gradient(180deg, #312D6F 0%, #45408D 100%)",
        bottomMenu:
          "radial-gradient(33.48% 103.75% at 52.2% 0%, #531B88 0%, #151240 100%)",
        bottomNavBtnRound: "linear-gradient(180deg,#9C40FF 0%,#3C39A8 100%)",
        bottomNavBtnRoundRimLight:
          "radial-gradient(46.67% 23.33% at 50% 100%, rgba(114, 187, 255, 0.80) 0%, rgba(75, 69, 234, 0.00) 100%)",
        bottomNavBtnIndicatorActive:
          "radial-gradient(44.58%_50%_at_50%_100%,rgba(109,93,255,0.60)_0%,rgba(42,28,91,0.00)_100%)",
        bottomNavBtnIndicator: "",
        pageTitle: "linear-gradient(180deg, #FFF 19.11%, #B3ACEF 71.43%)",
        tabNavSecondary: "linear-gradient(180deg,#312D6F 0%,#231F55 100%)",
        referFriendTopSection:
          "radial-gradient(73.33% 38.02% at 73.33% 58.07%, #371b9799 0%, rgba(0, 0, 0, 0.00) 100%)",
        timerProgressBar:
          "linear-gradient(#231F55,#231F55),linear-gradient(90deg, #7621CF 0%, #F59E0B 70%, #FCD34D 100%)",
        timerProgressStripes: "linear-gradient(-45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)",
        card: "radial-gradient(46.81% 58.96% at 50% 0%,#333230 0%,#151240 100%)",
      },
      backgroundColor: {
        backdrop: "#0C0629D9",
      },
      filter: {
        primary: "",
      },
    },
  },
  plugins: [import("@tailwindcss/typography")],
};
